import { atom } from 'jotai';

export const modalLayoutAtom = atom<'centered' | 'right-sidebar' | undefined>(
  'centered',
);
modalLayoutAtom.debugLabel = 'Modal/modalLayoutAtom';

export const modalBackgroundAtom = atom<string | null>(null);
modalLayoutAtom.debugLabel = 'Modal/modalBackgroundAtom';
